import moment from "moment";

export const formatTime = (date) => {
  const newDate = new Date(date);
  return newDate.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    amPM: true,
  });
};

export const formatDate = (date) => {
  return moment(date).format("MM/DD/YYYY");
};

export const formatDateSQL = (date) => {
  return moment(date).format("YYYY-MM-DD");
};

export const formatSummaryDateTime = (date, time) => {
  if (!date || !time) return false;
  const dates = date.split("-");
  const times = time.split(":");
  const year = dates[0];
  const month = parseInt(dates[1]);
  const day = dates[2];
  const hours = parseInt(times[0]);
  const minutes = times[1];

  let monthName;
  switch (month) {
    case 1:
      monthName = "January";
      break;
    case 2:
      monthName = "February";
      break;
    case 3:
      monthName = "March";
      break;
    case 4:
      monthName = "April";
      break;
    case 5:
      monthName = "May";
      break;
    case 6:
      monthName = "June";
      break;
    case 7:
      monthName = "July";
      break;
    case 8:
      monthName = "August";
      break;
    case 9:
      monthName = "September";
      break;
    case 10:
      monthName = "October";
      break;
    case 11:
      monthName = "November";
      break;
    case 12:
      monthName = "December";
      break;
    default:
      monthName = "Error";
  }

  const amPM = hours > 12 ? "PM" : "AM";
  const hour = hours === 12 || hours === 0 ? 12 : hours % 12;

  return `${monthName} ${day}, ${year} ${hour}: ${minutes} ${amPM}`;
};

export const format24HTimeAs12 = (time) => {
  if (!time) return false;
  const times = time.split(":");
  const hours = parseInt(times[0]);
  const minutes = times[1];
  const amPM = hours > 12 ? "PM" : "AM";
  const hour = hours === 12 || hours === 0 ? 12 : hours % 12;

  return `${hour}:${minutes} ${amPM}`;
};

export const formatSeconds = (seconds) => {
  if (seconds === "" || seconds === null || seconds === undefined) {
    return "";
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${minutes} minute(s), ${remainingSeconds} second(s)`;
};